module.exports = __webpack_public_path__ + "static/media/NunitoSans-Black.d95152ab.ttf";